import React, { useEffect } from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, children, title, wide, testId }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[100] flex items-end justify-center bg-[#352d38]/50 backdrop-blur-sm sm:items-center"
      onClick={onClose}
      data-testid={testId}
    >
      <div
        className={`kk-pop max-h-[92vh] w-full overflow-y-auto rounded-t-3xl bg-[#fffdfb] sm:rounded-3xl ${
          wide ? "sm:max-w-3xl" : "sm:max-w-lg"
        }`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {title !== undefined && (
          <div className="sticky top-0 z-10 flex items-center justify-between border-b border-[#f0eae3] bg-[#fffdfb]/95 px-5 py-4 backdrop-blur">
            <h2 className="text-[17px] font-bold">{title}</h2>
            <button
              onClick={onClose}
              className="grid h-9 w-9 place-items-center rounded-full bg-[#f7f3ef] text-[#8a7a80] hover:bg-[#efe4df]"
              data-testid="modal-close"
              aria-label="Tutup"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
